import { render, staticRenderFns } from "./CobranzaVidaSura.vue?vue&type=template&id=502c1b66"
import script from "./CobranzaVidaSura.vue?vue&type=script&lang=js"
export * from "./CobranzaVidaSura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports